import { FC, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputWithValidationProps } from '../models/FormInputWithValidation';
import styled from 'styled-components';
import { nanoid } from 'nanoid';

const StyledContainer = styled.div<{ $transparency?: boolean }>`
  width: 100%;
  div,
  input {
    background: ${(props) => props.$transparency && 'none !important'};
  }
`;

type OrbitaInputProps = {
  transparency?: boolean;
};

export function orbitaInputWithValidation<T>(
  InputComponent: FC<{
    invalid: boolean;
    errorText: string;
    value: any;
    onChange: any;
    onBlur: any;
  }>,
  options?: {
    reloadOnReset?: boolean;
  },
) {
  return ({
    name,
    registerOptions,
    transparency,
    ...props
  }: T & FormInputWithValidationProps & OrbitaInputProps) => {
    const { control } = useFormContext();
    const [key, setKey] = useState(nanoid());

    return (
      <StyledContainer $transparency={transparency}>
        <Controller
          name={name}
          control={control}
          rules={registerOptions}
          render={({ field: { onChange, onBlur, value }, fieldState }) => {
            if (options?.reloadOnReset) {
              useEffect(() => {
                if (!value) {
                  setKey(nanoid());
                }
              }, [value]);
            }

            return (
              <InputComponent
                key={key}
                onChange={onChange}
                onBlur={() => {
                  setKey(nanoid());
                  onBlur();
                }}
                value={value || ''}
                invalid={fieldState?.invalid}
                errorText={fieldState?.error?.message}
                {...props}
              />
            );
          }}
        />
      </StyledContainer>
    );
  };
}
